export const GET_STOCK_REQUEST = 'GET_STOCK_REQUEST';
export const GET_STOCK_SUCCESS = 'GET_STOCK_SUCCESS';
export const GET_STOCK_ERROR = 'GET_STOCK_ERROR';

export const ADD_STOCK_REQUEST = 'ADD_STOCK_REQUEST';
export const ADD_STOCK_SUCCESS = 'ADD_STOCK_SUCCESS';
export const ADD_STOCK_ERROR = 'ADD_STOCK_ERROR';

export const UPDATE_STOCK_REQUEST = 'UPDATE_STOCK_REQUEST';
export const UPDATE_STOCK_SUCCESS = 'UPDATE_STOCK_SUCCESS';
export const UPDATE_STOCK_ERROR = 'UPDATE_STOCK_ERROR';

export const DELETE_STOCK_REQUEST = 'DELETE_STOCK_REQUEST';
export const DELETE_STOCK_SUCCESS = 'DELETE_STOCK_SUCCESS';
export const DELETE_STOCK_ERROR = 'DELETE_STOCK_ERROR'; 